export default "__VITE_ASSET__99d2de5e__"